namespace Portico.Models {

    export interface IState {
		// url data
		root: string;
		fullRoute: string;
        // state data
        app: string;
        layout: string;
        page: string;
        intake: string;
        section: string;
        // "page" parameters
        ppid: string; // primary id
        psid: string; // secondary id
        // "section" parameters
        spid: string; // primary id
        ssid: string; // secondary id
        // "return to" parameters
        r2p: string; // return to page
        r2s: string; // return to section
    }

    export class State implements IState {
		// url data
		root: string;
		fullRoute: string;
        // state data
        app: string;
        layout: string;
        page: string;
        intake: string;
        section: string;
		// "page" parameters
		ppid: string; // primary id
        psid: string; // secondary id
        // "section" parameters
        spid: string; // primary id
        ssid: string; // secondary id
        // "return to" parameters
        r2p: string; // return to page
        r2s: string; // return to section

        constructor(obj?: IState) {
			this.root = null;
			this.fullRoute = null;
            this.app = null;
            this.layout = null;
            this.page = null;
            this.intake = null;
            this.section = null;
			this.ppid = null;
            this.psid = null;
            this.spid = null;
            this.ssid = null;
            this.r2p = null;
            this.r2s = null;

            if (obj) {
				this.root = obj.root;
				this.fullRoute = obj.fullRoute;
                this.app = obj.app;
                this.layout = obj.layout;
                this.page = obj.page;
                this.intake = obj.intake;
                this.section = obj.section;
				this.ppid = obj.ppid;
                this.psid = obj.psid;
                this.spid = obj.spid;
                this.ssid = obj.ssid;
                this.r2p = obj.r2p;
                this.r2s = obj.r2s;
            }
        }
    }
}
